import {
    IAnalyticsDisplayMessage,
    ICasinofiedAnalyticsService,
    IMessageActionTakenEventParams
} from "../../../../common/interfaces/casinofied-analytics-proxy.interface";
import BaseService from "../../base/base_service";
import ICasinofiedAnalyticsProxyService from "./casinofied_analytics_proxy_service_interface";

interface CasinofiedAnalyticsProxyServiceParams {
    getCasinofiedAnalyticsService: () => ICasinofiedAnalyticsService;
}

export default class CasinofiedAnalyticsProxyService extends BaseService implements ICasinofiedAnalyticsProxyService{
    static CLASS = 'CasinofiedAnalyticsProxyService';
    private _params: CasinofiedAnalyticsProxyServiceParams;

    init(params: CasinofiedAnalyticsProxyServiceParams) {
        this._params = params;
    }

    messageDisplay(params: IAnalyticsDisplayMessage): void {
        return this._params.getCasinofiedAnalyticsService().messageDisplay(params);
    }

    messageActionTaken(params: IMessageActionTakenEventParams): void {
        return this._params.getCasinofiedAnalyticsService().messageActionTaken(params);
    }
}